<template>
  <div style="text-align: center">
    <van-nav-bar title="购物车" left-text="" />
    <div v-if="!islogin" style="padding-top: 200px">
      <p>您还没有登录，请登录后查看购物车</p>
      <van-button round @click="ShowLogin" type="info">点击登录</van-button>
    </div>
    <div v-else-if="!datalist || datalist.length < 1" class="empty-box">
      <div>购物车暂时没有内容</div>
      <van-button type="info" plain hairline round to="/Index"
        >去商城看看</van-button
      >
    </div>
    <div v-else>
      <van-checkbox-group class="card-goods" v-model="checkedGoods">
        <van-checkbox
          class="card-goods__item"
          v-for="(item, idx) in datalist"
          :disabled="item.status !== 1 || item.GoodStock == 0"
          :key="idx"
          :name="item.ID"
          @click="chkChange"
        >
          <van-card
            :title="item.GoodsName"
            :desc="item.Specs"
            :num="item.Num"
            :price="item.UnitPrice"
            :thumb="item.GoodsImg"
          >
            <div slot="num" @click.stop="return false;">
              <van-stepper
                v-model="item.Num"
                @change="setCount(item.ID, item.Num)"
              />
            </div>
            <template #footer>
              <van-button
                type="danger"
                size="mini"
                round
                @click="RemoveCart(item)"
                >删除</van-button
              >
            </template>
          </van-card>
        </van-checkbox>
      </van-checkbox-group>

      <!-- <van-cell-group style="margin-top:10px;">
        <van-field v-model="OrderRemark" label="备注" placeholder="选填，请输入备注信息" />
      </van-cell-group> -->

      <!-- <van-popup v-model="showAddressEdit" round position="bottom" :style="{ height: '370px' }">
      <van-address-edit
        :area-list=areaList
        @save="SaveAddress"
        :AddressInfo=AddressInfo
      />
    </van-popup> -->

      <van-submit-bar
        :price="totalPrice"
        tip-icon="info-o"
        :loading="submitloading"
        :disabled="!checkedGoods.length"
        button-text="结算"
        @submit="onSubmit"
      >
        <!-- <template >
          <van-button  icon="logistics"  size="small" round @click="EidtAddress" type="info">地址</van-button>
      </template> -->
        <van-checkbox v-model="allChecked" @click="setChecked"
          >全选</van-checkbox
        >
      </van-submit-bar>
    </div>
  </div>
</template>

<script>
import {
  SubmitBar,
  Button,
  Card,
  AddressEdit,
  Popup,
  NavBar,
  CellGroup,
  Field,
  Stepper,
  Checkbox,
  CheckboxGroup,
} from "vant";
import area from "../utils/area";
import { debug } from "util";
import wx from "weixin-js-sdk";
export default {
  name: "",
  data() {
    return {
      areaList: area,
      // showAddressEdit:false,
      submitloading: false,
      totalPrice: 0,
      cartNum: 0,
      datalist: [],
      // addressdesc: "您还没填写收货地址,请点击左下角填写收货信息",
      ReciveAddr: {},
      // AddressInfo:{},
      // OrderRemark: "",
      checkedGoods: [],
      allChecked: false,
      isChecked: false,
    };
  },
  computed: {
    islogin() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    // onSubmit() {
    //   if(Object.keys(this.ReciveAddr).length === 0){
    //     this.$toast("请先填写收货地址");
    //     return;
    //   }
    //   var that=this;
    //   this.$http.post("Order/CreateWebOrder?orderremark="+this.OrderRemark,this.ReciveAddr).then(res=>{
    //     if(res.data=="success"){
    //       that.$toast("操作成功");
    //       that.GetData();
    //     }else{
    //       that.$toast(res.data);
    //     }
    //   });
    // },
    wxconfig: function () {
      var that = this;
      var url = encodeURIComponent(location.href.split("#")[0]);
      // url=encodeURIComponent("https://sale.reaca.net")
      this.$http.get("WeChatApi/GetJSConfig?url=" + url).then((response) => {
        console.log(response);
        wx.config({
          debug: false,
          appId: response.data.Data.appId,
          timestamp: parseInt(response.data.Data.timestamp),
          nonceStr: response.data.Data.noncestr,
          signature: response.data.Data.sign,
          jsApiList: [
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "onMenuShareAppMessage",
          ],
        });

        wx.ready(function () {
          wx.updateAppMessageShareData({
            title: "天力管", // 分享标题
            desc: "天力管水电工程师活动中心", // 分享描述
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl: "https://oss.reaca.net/webPic/vr_logo.png", // require("../../assets/vr_logo.png"), // 分享图标
            success: function () {
              console.log("success");
              // 设置成功
            },
          });
          wx.updateTimelineShareData({
            title: "天力管", // 分享标题
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl: "https://oss.reaca.net/webPic/vr_logo.png", //require("../../assets/vr_logo.png"), // 分享图标
            success: function () {
              console.log("success");
            },
          });
          wx.onMenuShareAppMessage({
            title: "天力管", // 分享标题
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl: "https://oss.reaca.net/webPic/vr_logo.png", //require("../../assets/vr_logo.png"), // 分享图标
            success: function () {
              console.log("success");
            },
          });
        });
        // that.LoadImg(res);
      });
    },
    onSubmit(item) {
      if (this.checkedGoods.length < 1) {
        this.$toast("请选择商品结算");
        return;
      }
      this.$router.push({
        name: "Confirm",
        params: { skuid: this.checkedGoods, from: "cart" },
      });
    },
    ShowLogin() {
      // this.$store.commit("showLogin");
      this.$router.push({
        name: "Login",
        params: {},
      });
    },
    RemoveCart(item) {
      console.log(item);
      var that = this;
      this.$http.get("Order/DeleteOrderDetail?id=" + item.ID).then((res) => {
        that.GetData();
      });
    },
    // GetData() {
    //   if (this.islogin) {
    //     var cartNum = 0;
    //     var that = this;
    //     this.$http.get("Order/GetOrderDetail").then((res) => {
    //       that.$toast.clear();
    //       that.datalist = res.data.Data;
    //       that.totalPrice=0;
    //       that.datalist.forEach((item, idx, array) => {
    //         cartNum += item.Num;
    //         that.totalPrice+=item.RowPrice*100;
    //         array[idx].GoodsImg =
    //           that.$file.url +
    //           "Images/Mall/GoodsImg/" +
    //           item.GoodsCode +
    //           "/" +
    //           item.GoodsImg.split(",")[0];
    //       });
    //       that.$store.commit("setCartCount", cartNum);
    //     });
    //   }
    // },
    GetData() {
      if (this.islogin) {
        var cartNum = 0;
        var that = this;
        this.$http.get("Order/GetOrderDetail").then((res) => {
          that.$toast.clear();
          that.datalist = res.data.Data;
          that.datalist.forEach((item, idx, array) => {
            array[idx].GoodsImg =
              that.$file.url +
              "Images/Mall/GoodsImg/" +
              item.GoodsCode +
              "/" +
              item.GoodsImg.split(",")[0];
          });
        });
        that.$store.commit("setCartCount", cartNum);
      }
    },
    // SaveAddress(data){
    //   this.AddressInfo=data;
    //   this.showAddressEdit=false;
    //   this.addressdesc=data.province+data.city+data.county+data.addressDetail+data.name+data.tel+"收";
    //   this.ReciveAddr={
    //     userName:data.name,
    //     telNumber:data.tel,
    //     provinceName:data.province,
    //     cityName:data.city,
    //     countyName:data.county,
    //     detailInfo:data.addressDetail
    //   };

    // },
    // EidtAddress(){
    //   this.showAddressEdit=true;
    // },
    getTotal() {
      var cartNum = 0;
      var that = this;
      that.totalPrice = 0;
      that.datalist.forEach((item, idx, array) => {
        if (that.checkedGoods.indexOf(item.ID) !== -1) {
          cartNum += item.Num;
          that.totalPrice += item.RowPrice * 100;
        }
      });
      that.$store.commit("setCartCount", cartNum);
    },
    setChecked() {
      this.isChecked = false;
      this.checkedGoods = [];
      this.totalPrice = 0;
      if (this.allChecked) {
        this.datalist.forEach((item, idx, array) => {
          if (item.status === 1 && item.GoodStock > 0) {
            this.isChecked = true;
            this.checkedGoods.push(item.ID);
          }
        });
      }
      this.getTotal();
    },
    setCount(id, num) {
      var that = this;
      that.$http
        .get("Order/UpdateCartNum?id=" + id + "&num=" + num)
        .then((res) => {
          that.GetData();
        });
    },
    chkChange() {
      if (this.checkedGoods.length < this.datalist.length) {
        this.allChecked = false;
      } else {
        this.allChecked = true;
      }
      this.getTotal();
      console.log(this.checkedGoods);
    },
  },
  created() {
    this.wxconfig();
    this.GetData();
  },
  components: {
    [SubmitBar.name]: SubmitBar,
    [Button.name]: Button,
    [Card.name]: Card,
    [AddressEdit.name]: AddressEdit,
    [Popup.name]: Popup,
    [NavBar.name]: NavBar,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Stepper.name]: Stepper,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
  },
};
</script>

<style>
.van-submit-bar {
  bottom: 51px;
}
.van-card__title {
  max-width: 175px;
  text-align: left;
  padding-left: 15px;
}
.van-card__bottom {
  text-align: left;
  padding-left: 15px;
}
.van-card__content {
  justify-content: space-around;
}
.van-card {
  margin-right: 10px;
  padding: 11px;
  background-color: #fff;
  border-radius: 8px;

  margin-left: 10px;
  margin-top: 10px;
}
.van-submit-bar__tip {
  text-align: left;
}
.empty-box {
  text-align: center;
  padding-top: 40px;
  padding-bottom: 40px;
  color: #999;
}
.van-button {
  margin-top: 10px;
}

.card-goods {
  padding: 0px 0;
}
.card-goods__item {
  position: relative;
}
.van-checkbox__label {
  position: relative;
  width: 100%;
  height: auto;
  padding: 0 10px 0 15px;
  box-sizing: border-box;
}
.van-checkbox__icon {
  position: relative;
  top: 50%;
  left: 10px;
  z-index: 1;
  position: absolute;
  margin-top: -10px;
}
.van-card__price {
  position: relative;
  color: #f44;
}
.van-card__desc {
  margin-left: 15px;
  margin-top: 5px;
  text-align: left;
}
</style>